export default __webpack_public_path__ + "static/page-404-image-d77cdfce9a69c321d530142d34e780ba.svg";